import React from "react";

export const MeasureDropdown = ({ selection, setSelection, options }) => {
  return (
    <div>
      <select
        className="border border-gray-300 rounded-md p-1 ml-2 flex-1"
        value={selection}
        onChange={(e) => setSelection(e.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
